import _get from 'lodash/get';
import _values from 'lodash/values';
import { ASSET_RESOURCES } from 'constant';
import { APP_ASSETS, WEB_ASSETS } from 'commons-ui/src/constants';

export const assetsTagDependencyResolver = (props: any, dependencyValues: any) => {
	const assetType = _get(dependencyValues, '0');
	if (assetType) {
		if (assetType === ASSET_RESOURCES.website) {
			return { options: _values(WEB_ASSETS), disabled: false };
		}
		return { options: _values(APP_ASSETS), disabled: false };
	}
	return null;
};

export const assetsTagDependencyResolverEdit = (props: any, dependencyValues: any) => {
	const assetType = _get(dependencyValues, '0');
	if (assetType) {
		if (assetType === ASSET_RESOURCES.website) {
			return { options: _values(WEB_ASSETS), disabled: true };
		}
		return { options: _values(APP_ASSETS), disabled: true };
	}
	return null;
};

export const customTagResolver = (props: any, dependencyValues: any) => {
	const tag = _get(dependencyValues, '0');
	if (tag) {
		if (tag === 'custom') {
			return { required: true, disabled: false };
		}
		return { disabled: true };
	}
	return null;
};

export const customTagResolverEdit = (props: any, dependencyValues: any) => {
	const tag = _get(dependencyValues, '0');
	if (tag) {
		if (tag === 'custom') {
			return { required: true, disabled: true };
		}
		return { disabled: true };
	}
	return null;
};
